"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    "report-table": require("./elements/Table.vue").default
  },

  props: ["item"],

  data: function data() {
    return {
      tableHeader: ["", "Total"]
    };
  },


  methods: {
    getDataForTable: function getDataForTable(data) {
      if (Fn.isObject(data)) {
        data = _.values(data);
      }

      return data.map(function (item) {
        return [item.name, item.total];
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/reports/tables/SummaryTable.vue
// module id = p5Qp
// module chunks = 0 1